import env from '@beam-australia/react-env';
import { IMAGES } from '../constants/paths';

function getImage(image) {
  const output = !image.value ? image.value : image.default;

  if (!output) {
    return;
  }

  return IMAGES + output;
}

const mainLogo = {
  default: 'mainLogo.png',
  value: env('EXT_MAIN_LOGO'),
};

const fallbackImage = {
  default: 'fallbackImage.png',
  value: env('EXT_FALLBACKIMAGE'),
};

const headerLogo = {
  default: null,
  value: env('EXT_HEADER_LOGO'),
};

const images = {
  mainLogo: getImage(mainLogo),
  fallbackImage: getImage(fallbackImage),
  headerLogo: getImage(headerLogo),
};

export default images;
